export const initHomepageHeroSection = () => {
  const homepageHeroSection = document.querySelector('.section--homepage-hero');

  if (!homepageHeroSection) {
    // No action needed if the element is not present
  }
};
